/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ProcedurePrice from './procedure-price';
import ProcedurePriceDetail from './procedure-price-detail';
import ProcedurePriceUpdate from './procedure-price-update';
import ProcedurePriceDeleteDialog from './procedure-price-delete-dialog';

const ProcedurePriceRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ProcedurePrice />} />
    <Route path="new" element={<ProcedurePriceUpdate />} />
    <Route path=":id">
      <Route index element={<ProcedurePriceDetail />} />
      <Route path="edit" element={<ProcedurePriceUpdate />} />
      <Route path="delete" element={<ProcedurePriceDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ProcedurePriceRoutes;
